var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "site-header",
      class: { open: _vm.isOpen },
      attrs: { id: "site-header" }
    },
    [
      _c("div", { staticClass: "content-max-width" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("div", { staticClass: "phone desktop" }, [
            _c("a", { attrs: { href: _vm.data.phone_url } }, [
              _vm._v(_vm._s(_vm.data.phone))
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("In an emergency call 111")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("nav", [
        _c("div", { staticClass: "content-max-width" }, [
          _c(
            "ul",
            { staticClass: "top" },
            _vm._l(_vm.menu, function(link, index) {
              return _c("li", { key: index }, [
                _c(
                  "a",
                  {
                    class: { active: link.url == _vm.currentPage },
                    attrs: { href: link.url }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(link.title) + "\n          "
                    )
                  ]
                )
              ])
            }),
            0
          ),
          _vm._v(" "),
          _vm._m(1)
        ])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "hamburger mob", on: { click: _vm.toggleMenu } },
        [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "phone mob" }, [
        _c(
          "div",
          {
            staticClass: "flex items-center justify-between content-max-width"
          },
          [
            _c("a", { attrs: { href: _vm.data.phone_url } }, [
              _vm._v(_vm._s(_vm.data.phone))
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("In an emergency call 111")])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bg mob", class: { open: _vm.isOpen } })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo", attrs: { href: "/" } }, [
      _c("img", { attrs: { src: "/images/logo.png", alt: "Helensville" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "mob-logo mob", attrs: { href: "/" } }, [
      _c("img", { attrs: { src: "/images/logo.png", alt: "Helensville" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }